import { render, staticRenderFns } from "./JiraTodoList.vue?vue&type=template&id=2712904b&"
import script from "./JiraTodoList.vue?vue&type=script&lang=js&"
export * from "./JiraTodoList.vue?vue&type=script&lang=js&"
import style0 from "./JiraTodoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports